import React, { ReactElement } from 'react';
import {
  Grid,
  GridColumn,
  GridDataStateChangeEvent,
} from '@progress/kendo-react-grid';
import { process, State } from '@progress/kendo-data-query';

import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../store';
import { GetString } from '../../StringResourceManager';
import { useEffect } from 'react';
import { LocalizationProvider, loadMessages } from '@progress/kendo-react-intl';
import { locales, LocaleInterface } from '../../AlertsGrid/GridLocale';
import esMessages from '../../../utils/gridMessageKey.json';
loadMessages(esMessages, 'fr-CA');

interface FeaturesChangesInfo {
  FeatureName: string;
  SettingsGroupName: string;
  SettingName: string;
  Value: string;
}

interface Props {
  configChanges: any[];
}

const ConfigChangesGrid: React.FC<Props> = ({
  configChanges,
}): ReactElement => {
  const initialDataState: State = { group: [] };

  const [dataState, setDataState] = React.useState<State>(initialDataState);

  const [gridData, setGridData] = React.useState<any[]>([]);

  const [isConfigFeatureChanges, setIsConfigFeatureChanges] =
    React.useState<boolean>(configChanges[0].ID != undefined);

  const [currentLocale, setCurrentLocale] = React.useState<LocaleInterface>(
    locales[0]
  );

  const selectedLanguage: string = useSelector(
    (state: ApplicationState) => state.userSettingsReducer.selectedLanguage
  );

  const processFeatureChanges = () => {
    let result: FeaturesChangesInfo[] = [];
    for (
      let featureIndex = 0;
      featureIndex < configChanges.length;
      featureIndex++
    ) {
      for (
        let settingsGroupIndex = 0;
        settingsGroupIndex < configChanges[featureIndex].SettingsGroups.length;
        settingsGroupIndex++
      ) {
        for (
          let settingIndex = 0;
          settingIndex <
          configChanges[featureIndex].SettingsGroups[settingsGroupIndex]
            .Settings.length;
          settingIndex++
        ) {
          let info = {
            FeatureName: configChanges[featureIndex].Name,
            SettingsGroupName:
              configChanges[featureIndex].SettingsGroups[settingsGroupIndex]
                .Name,
            SettingName:
              configChanges[featureIndex].SettingsGroups[settingsGroupIndex]
                .Settings[settingIndex].Name,
            Value:
              configChanges[featureIndex].SettingsGroups[settingsGroupIndex]
                .Settings[settingIndex].InitValue,
          };
          result.push(info);
        }
        if (
          configChanges[featureIndex].SettingsGroups[settingsGroupIndex]
            .Settings.length == 0
        )
          configChanges[featureIndex].SettingsGroups.splice(
            settingsGroupIndex,
            1
          );
      }
    }

    setGridData(result);
  };

  useEffect(() => {
    if (configChanges[0].ID != undefined) {
      processFeatureChanges();
    } else {
      setGridData(configChanges);
    }
  }, [configChanges]);

  useEffect(() => {
    if (selectedLanguage == 'English') {
      setCurrentLocale(locales[0]);
    } else if (selectedLanguage == 'French') {
      setCurrentLocale(locales[1]);
    }
  }, [selectedLanguage]);

  return (
    <LocalizationProvider language={currentLocale.language}>
      <Grid
        style={
          isConfigFeatureChanges
            ? { width: '870px', height: '200px' }
            : { width: '700px', height: '200px' }
        }
        pageable={{
          buttonCount: 4,
          pageSizes: [10, 20, 50, 100, 500],
        }}
        take={100}
        data={process(gridData, dataState)}
        {...dataState}
        onDataStateChange={(e: GridDataStateChangeEvent) => {
          setDataState(e.dataState);
        }}
      >
        {isConfigFeatureChanges ? (
          <GridColumn
            field="FeatureName"
            title={GetString('FEATURE')}
            width="200px"
          />
        ) : null}
        {isConfigFeatureChanges ? (
          <GridColumn
            field="SettingsGroupName"
            title={GetString('SETTINGS_GROUP')}
            width="200px"
          />
        ) : null}
        {isConfigFeatureChanges ? (
          <GridColumn
            field="SettingName"
            title={GetString('SETTING')}
            width="200px"
          />
        ) : null}

        {!isConfigFeatureChanges ? (
          <GridColumn
            field="Category"
            title={GetString('COLUMN_TITLE_LANE_CATEGORY')}
            width="200px"
          />
        ) : null}
        {!isConfigFeatureChanges ? (
          <GridColumn
            field="Name"
            title={GetString('COLUMN_TITLE_LANE_NAME')}
            width="210px"
          />
        ) : null}

        <GridColumn
          field="Value"
          title={GetString('COLUMN_TITLE_LANE_VALUE')}
          width="240px"
        />
      </Grid>
    </LocalizationProvider>
  );
};

export default ConfigChangesGrid;
